import React from 'react';
import { Footer } from '../home/Footer';
import Content from './Content';
import '../home/home.generated.css';

function index(): JSX.Element {
  return (
    <>
      <Content />
      <div className='strada-public-home'>
        <Footer />
      </div>
      {/* <!-- Start of HubSpot Embed Code --> */}
      <script type='text/javascript' id='hs-script-loader' async defer src='//js.hs-scripts.com/7523573.js' />
      {/* <!-- End of HubSpot Embed Code --> */}
    </>
  );
}

export default index;
